import {
  DocumentMagnifyingGlassIcon,
  EllipsisVerticalIcon,
  PencilSquareIcon,
  TrashIcon
} from '@heroicons/react/24/outline'
import { map } from 'lodash'
import { ComponentProps, ReactNode, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Menu, { MenuItems } from '@/components/TailwindUI/Menu'
import cn from '@/utilities/cn'

import messages from './messages'

export type EditMenuProps = {
  disabled?: boolean
  icon?: ReactNode
  menuItems: { label: ReactNode; onClick: (rowData: any) => void }[]
  rowData: any
}
export const defaultEditLabel = (
  <>
    <PencilSquareIcon className="mr-3 h-5 w-5 text-zinc-400 group-hover:text-zinc-500" />
    <FormattedMessage {...messages.edit} />
  </>
)

export const defaultDeleteLabel = (
  <>
    <TrashIcon className="mr-3 h-5 w-5 text-zinc-400 group-hover:text-zinc-500" />
    <FormattedMessage {...messages.delete} />
  </>
)

export const defaultLogsLabel = (
  <>
    <DocumentMagnifyingGlassIcon className="mr-3 h-5 w-5 text-zinc-400 group-hover:text-zinc-500" />
    <FormattedMessage {...messages.viewLogs} />
  </>
)
export default function EditMenu({
  disabled = false,
  menuItems,
  icon = <EllipsisVerticalIcon className="h-7 w-7 stroke-zinc-400 hover:stroke-zinc-600" />,
  rowData
}: EditMenuProps & ComponentProps<'button'>) {
  const [direction, setDirection] = useState<'up' | 'down'>('down')

  const itemsList = map(menuItems, ({ label, onClick }) => {
    return { label, onClick: () => onClick(rowData) }
  })

  return (
    <Menu
      className={cn({ hidden: disabled }, 'rounded text-zinc-500 hover:bg-white')}
      icon={icon}
      onClick={e => {
        e.stopPropagation()
        // If overflows bottom of screen, switch direction the menu opens
        if (window.screen.availHeight - e.clientY < 350) {
          setDirection('up')
        } else {
          setDirection('down')
        }
      }}
      direction={direction}
    >
      <MenuItems items={itemsList} className="py-1" />
    </Menu>
  )
}

//TODO: secondary list of menu items like in App Builder
